<template>
    <new-modal
        size="3xl"
        modal-classes="rounded bg-white p-0"
        :show-header="false"
    >
        <template #trigger>
            <span class="link underline">How does that work?</span>
        </template>

        <template #content>
            <div
                class="bg-primary-500 p-6 text-[16px] leading-loose text-white"
            >
                <div class="text-[18px] font-semibold">
                    Earn continuing education hours using
                    <span class="italic">podcasts</span>
                </div>
                Many of our podcasts are available for free below. But you can
                also earn CE hours when listening to podcasts once you register
                at EMT-CE.com
            </div>
            <div class="flex flex-col gap-4 p-6">
                <div class="text-[16px] text-gray-700">How to earn</div>
                <div class="flex items-start gap-2">
                    <svg
                        class="h-[30px] w-[30px] flex-none"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="15" cy="15" r="15" fill="#045699" />
                        <path
                            d="M16.2955 9.36364V21H14.8864V10.8409H14.8182L11.9773 12.7273V11.2955L14.8864 9.36364H16.2955Z"
                            fill="white"
                        />
                    </svg>
                    <div class="">
                        Register at EMT-CE.com and enter your NREMT number
                    </div>
                </div>
                <div class="flex items-start gap-2">
                    <svg
                        class="h-[30px] w-[30px] flex-none"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="15" cy="15" r="15" fill="#045699" />
                        <path
                            d="M11.2045 20V18.9773L15.0455 14.7727C15.4962 14.2803 15.8674 13.8523 16.1591 13.4886C16.4508 13.1212 16.6667 12.7765 16.8068 12.4545C16.9508 12.1288 17.0227 11.7879 17.0227 11.4318C17.0227 11.0227 16.9242 10.6686 16.7273 10.3693C16.5341 10.0701 16.2689 9.83901 15.9318 9.67614C15.5947 9.51326 15.2159 9.43182 14.7955 9.43182C14.3485 9.43182 13.9583 9.52462 13.625 9.71023C13.2955 9.89205 13.0398 10.1477 12.858 10.4773C12.6799 10.8068 12.5909 11.1932 12.5909 11.6364H11.25C11.25 10.9545 11.4072 10.3561 11.7216 9.84091C12.036 9.32576 12.464 8.92424 13.0057 8.63636C13.5511 8.34848 14.1629 8.20455 14.8409 8.20455C15.5227 8.20455 16.1269 8.34848 16.6534 8.63636C17.1799 8.92424 17.5928 9.3125 17.892 9.80114C18.1913 10.2898 18.3409 10.8333 18.3409 11.4318C18.3409 11.8598 18.2633 12.2784 18.108 12.6875C17.9564 13.0928 17.6913 13.5455 17.3125 14.0455C16.9375 14.5417 16.4167 15.1477 15.75 15.8636L13.1364 18.6591V18.75H18.5455V20H11.2045Z"
                            fill="white"
                        />
                    </svg>

                    <div class="">
                        Use our course platform to listen to podcasts
                    </div>
                </div>
                <div class="flex items-start gap-2">
                    <svg
                        class="h-[30px] w-[30px] flex-none"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="15" cy="15" r="15" fill="#045699" />
                        <path
                            d="M15.1364 20.1591C14.3864 20.1591 13.7178 20.0303 13.1307 19.7727C12.5473 19.5152 12.0833 19.1572 11.7386 18.6989C11.3977 18.2367 11.2121 17.7008 11.1818 17.0909H12.6136C12.6439 17.4659 12.7727 17.7898 13 18.0625C13.2273 18.3314 13.5246 18.5398 13.892 18.6875C14.2595 18.8352 14.6667 18.9091 15.1136 18.9091C15.6136 18.9091 16.0568 18.822 16.4432 18.6477C16.8295 18.4735 17.1326 18.2311 17.3523 17.9205C17.572 17.6098 17.6818 17.25 17.6818 16.8409C17.6818 16.4129 17.5758 16.036 17.3636 15.7102C17.1515 15.3807 16.8409 15.1231 16.4318 14.9375C16.0227 14.7519 15.5227 14.6591 14.9318 14.6591H14V13.4091H14.9318C15.3939 13.4091 15.7992 13.3258 16.1477 13.1591C16.5 12.9924 16.7746 12.7576 16.9716 12.4545C17.1723 12.1515 17.2727 11.7955 17.2727 11.3864C17.2727 10.9924 17.1856 10.6496 17.0114 10.358C16.8371 10.0663 16.5909 9.83901 16.2727 9.67614C15.9583 9.51326 15.5871 9.43182 15.1591 9.43182C14.7576 9.43182 14.3788 9.50568 14.0227 9.65341C13.6705 9.79735 13.3826 10.0076 13.1591 10.2841C12.9356 10.5568 12.8144 10.8864 12.7955 11.2727H11.4318C11.4545 10.6629 11.6383 10.1288 11.983 9.67045C12.3277 9.20833 12.7784 8.84848 13.3352 8.59091C13.8958 8.33333 14.5114 8.20455 15.1818 8.20455C15.9015 8.20455 16.5189 8.35038 17.0341 8.64205C17.5492 8.92992 17.9451 9.31061 18.2216 9.78409C18.4981 10.2576 18.6364 10.7689 18.6364 11.3182C18.6364 11.9735 18.464 12.5322 18.1193 12.9943C17.7784 13.4564 17.3144 13.7765 16.7273 13.9545V14.0455C17.4621 14.1667 18.036 14.4792 18.4489 14.983C18.8617 15.483 19.0682 16.1023 19.0682 16.8409C19.0682 17.4735 18.8958 18.0417 18.5511 18.5455C18.2102 19.0455 17.7443 19.4394 17.1534 19.7273C16.5625 20.0152 15.8902 20.1591 15.1364 20.1591Z"
                            fill="white"
                        />
                    </svg>

                    <div class="">
                        Take a short test about the podcast’s contents
                    </div>
                </div>
                <div class="flex items-start gap-2">
                    <svg
                        class="h-[30px] w-[30px] flex-none"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="15" cy="15" r="15" fill="#045699" />
                        <path
                            d="M10.9318 17.6136V16.4545L16.0455 8.36364H16.8864V10.1591H16.3182L12.4545 16.2727V16.3636H19.3409V17.6136H10.9318ZM16.4091 20V17.2614V16.7216V8.36364H17.75V20H16.4091Z"
                            fill="white"
                        />
                    </svg>

                    <div class="">
                        We’ll automatically sync your hours to the NREMT (we’re
                        CAPCE accredited)
                    </div>
                </div>
            </div>
        </template>
    </new-modal>
</template>
<script>
import NewModal from "@/Components/NewModal";

export default {
    name: "emtpro-explainer-modal",
    components: { NewModal },
};
</script>
